import { Component, OnInit, HostListener, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AssetService, AssetData, LayoutConfigsMap, CellConfig, LayoutConfig } from '../../../../../services/asset/asset.service';
import { ProductConfigurationService } from '../../../../../services/product_configuration/product_configuration.service';
import { awsPath } from '../../../../../configurations/configuration';


type LayoutKey = 'grid9' | 'grid4' | 'grid2' | 'gridH';

interface CurrentPlayer { layoutKey: LayoutKey; playerIndex: number; }
declare var PubNub: any;
const VALID_ACTIONS = ['start', 'stream', 'weather', 'technical', 'stop', 'clear'];
type ActionT = typeof VALID_ACTIONS[number];


@Component({
  selector: 'app-asset-config-v1',
  templateUrl: './v1.component.html',
  styleUrls: ['./v1.component.scss']
})
export class AssetConfigV1Component implements OnInit,OnDestroy {

  // Schema-version switcher (owned by the host; rendered beside the page title).
  @Input() schemaVersion = 1;
  @Output() schemaVersionChange = new EventEmitter<number>();

  onSchemaVersionChange(v: number | string) {
    this.schemaVersionChange.emit(Number(v) === 2 ? 2 : 1);
  }

  // state
  asset: AssetData;
  layoutConfigs: LayoutConfigsMap;

  layoutStates: { grid9: boolean; grid4: boolean; grid2: boolean; gridH: boolean } = {
    grid9: true, grid4: true, grid2: true, gridH: true
  };

  
  // stats
  totalLayouts = 4;
  enabledLayouts = 4;
  configuredStreams = 0;
  lastUpdated = '--';

  isLive = false;
  currentOverlay: 'stream' | 'technical' | 'weather' | null = null;
  isStarting = false;
  isStopping = false;
  pubnub: any = null;
  pubnubReady = false;
  pubnubListenerRef: any = null;
  activeAction: ActionT = 'start';
  lastTokenProcessed = '';
  lastAppliedAction = '';
  lastAppliedAt = 0;

  // popups
  showConfigPopup = false;
  showAdPopup = false;
  showAssetEditPopup = false;
  currentPlayer: CurrentPlayer | null = null;

  // config form (cell)
  form_isAdOnlySlot = false; // true for gridH top/bottom ad slots (indices 9, 10)
  form_cellType: 'camera' | 'ad' = 'camera';
  form_camIndex: number | null = null;
  form_width = '';
  form_height = '';
  form_x = '';
  form_y = '';

  // ad form fields
  form_adProvider: 'image' | 'adsense' | 'gam' = 'image';
  form_imageUrl = '';
  form_adImageUploading = false;
  form_redirectUrl = '';
  form_alt = '';
  form_adClient = '';
  form_adSlot = '';
  form_adUnitPath = '';
  form_adSizes = '[[970,250],[728,90]]';
  form_adDivId = '';

  // asset edit temp
  tmpAsset: AssetData;
  assetPath: any;
  stream_data:any; 

  constructor(private svc: AssetService, private activatedRoute: ActivatedRoute, private toastrService: ToastrService, private productConfigurationService: ProductConfigurationService) {}

  get isLiveContent(): boolean {
    return this.asset && this.asset.contentType === 'live';
  }

  ngOnInit() {
    this.layoutConfigs = this.svc.getdefaultLayouts();
    this.updateStats();
    this.activatedRoute.params.subscribe((params: Params) => {
      this.assetPath = params['id'];
      this.editAssetInfo(this.assetPath);
     // this.asset = this.svc.getAssetData(this.assetPath);

  });


  this.svc.getConfig(this.assetPath).subscribe((data => {
    console.log("data",data.data.asset_id)
    if(data.data.asset_id){
    this.stream_data = JSON.parse(data.data.config_data)
    let asset_data = this.stream_data

    this.asset = asset_data
    console.log("this.asset",this.stream_data)
    this.asset.id = this.assetPath
    this.tmpAsset = {
      id: this.assetPath,
      videoUrl: this.asset.videoUrl,
      video_H_Url: this.asset.video_H_Url,
      video_dual_Url: this.asset.video_dual_Url,
      video_quad_Url: this.asset.video_quad_Url,
      audiourl: this.asset.audiourl,
      programcutUrl: this.asset.programcutUrl,
      streamUrls: this.asset.streamUrls,
      Program:this.asset.Program,
      contentType: this.asset.contentType,
      signalChannel: this.asset.signalChannel,
      chatEnabled: this.getChatEnabled(this.asset),
      chatChannel: this.getChatChannel(this.asset),
      chatEnablePrivate: this.getChatEnablePrivate(this.asset),
      chatRoomPrefix: this.getChatRoomPrefix(this.asset),
      multiViewEnabled:this.asset.multiViewEnabled

    };
    this.svc.setAssetData(this.tmpAsset);
    this.svc.setLayouts(asset_data.layoutConfigs);
    this.layoutConfigs = asset_data.layoutConfigs;
    this.migrateGridHLayout();
    this.migrateGrid2Layout();
    this.maybeInitPubNub();

  } else {
    this.asset = this.svc.getAssetData(this.assetPath);
    this.migrateGrid2Layout();
    this.maybeInitPubNub();

  }
  }));

  }

  ngOnDestroy() {
    console.log('Layout page destroyed — clearing localStorage');
    this.svc.clearLayoutAndAsset();
  }

  maybeInitPubNub() {
    if (!this.asset || this.asset.contentType !== 'live') {
      this.applyActionState('start'); // default
      return;
    }
    var ch = (this.asset.signalChannel || '').trim();
    if (!ch) return;
  
    // If already init’d to the same channel, skip
    if (this.pubnub && this.pubnubReady && this.pubnub.__channel === ch) return;
  
    // Tear down previous (if any)
    if (this.pubnub) {
      try {
        if (this.pubnubListenerRef) this.pubnub.removeListener(this.pubnubListenerRef);
        if (this.pubnub.__channel) this.pubnub.unsubscribe({ channels: [this.pubnub.__channel] });
      } catch (_) {}
    }
  
    // Init
    this.pubnub = new PubNub({
      publishKey: 'pub-c-61be60a0-f004-4c1d-8afd-58ba45281614',
      subscribeKey: 'sub-c-15859c61-2a14-48e3-adbb-81b39c3e53e0',
      uuid: 'Volta_live' // UUID
    });
    this.pubnub.__channel = ch;
    var self = this;
  
    // Single listener instance we can remove later
    this.pubnubListenerRef = {
      // Handle only persisted overlay messages for state; ignore signals to avoid doubles
      message: function(mev: any) {
        var msg = mev && mev.message ? mev.message : null;
        var token = mev && mev.timetoken ? String(mev.timetoken) : '';
        var publisher = mev && mev.publisher ? String(mev.publisher) : '';
  
        // ignore our own echo
        if (publisher === self.pubnub.getUUID()) return;
  
        // de-dup by timetoken
        if (token && token === self.lastTokenProcessed) return;
        self.lastTokenProcessed = token;
  
        if (!msg || msg.type !== 'overlay') return;
        var act = (msg.action || '').toString().toLowerCase();
  
        // accept known actions only
        var known = false;
        for (var i=0;i<VALID_ACTIONS.length;i++) if (act === VALID_ACTIONS[i]) { known = true; break; }
        if (!known) return;
  
        // drop rapid duplicates
        if (act === self.lastAppliedAction && (Date.now() - self.lastAppliedAt) < 800) return;
  
        self.applyActionState(act as ActionT);
      },
      status: function(st: any) {
        // optional: log PNConnectedCategory, etc.
      }
    };
  
    this.pubnub.addListener(this.pubnubListenerRef);
    this.pubnub.subscribe({ channels: [ch] });
    this.pubnubReady = true;
  
    // Fetch last persisted overlay (history) once
    this.fetchAndApplyLastAction();
  }
  
  fetchAndApplyLastAction() {
    if (!this.pubnub || !this.asset || !this.asset.signalChannel) {
      this.applyActionState('start');
      return;
    }
    var ch = this.asset.signalChannel;
    var self = this;
  
    this.pubnub.fetchMessages({ channels: [ch], count: 25 }, function(status: any, resp: any) {
      if (status && status.error) {
        console.warn('fetchMessages error', status);
        self.applyActionState('start');
        return;
      }
      var arr = resp && resp.channels && resp.channels[ch] ? resp.channels[ch] : [];
      // newest -> oldest
      for (var i = arr.length - 1; i >= 0; i--) {
        var itm = arr[i];
        var msg = itm && itm.message ? itm.message : null;
        if (!msg || msg.type !== 'overlay') continue;
        var act = (msg.action || '').toString().toLowerCase();
        for (var k=0;k<VALID_ACTIONS.length;k++) {
          if (act === VALID_ACTIONS[k]) {
            self.applyActionState(act as ActionT);
            return;
          }
        }
      }
      self.applyActionState('start'); // default if none found
    });
  }
  
  
  applyActionState(action: string) {
    // normalize
    var a = (action || '').toLowerCase();
    // default unknown -> start
    var known = false;
    for (var i = 0; i < VALID_ACTIONS.length; i++) {
      if (a === VALID_ACTIONS[i]) { known = true; break; }
    }
    if (!known) a = 'start';
  
    // reset overlay unless we set it below
    this.currentOverlay = null;
  
    switch (a) {
      case 'start':
        this.isLive = true;
        break;
      case 'stop':
        this.isLive = false;
        break;
      case 'stream':
      case 'weather':
      case 'technical':
        // overlays don't force live on/off; keep last isLive
        this.currentOverlay = a as any;
        break;
      case 'clear':
        // explicitly no overlay
        break;
    }
  
    this.activeAction = a as any;
  }
  
  

    sendOverlayAction(action: string) {
      // update local immediately for snappy UI
      this.applyActionState(action);
    
      if (!this.pubnub || !this.isLiveContent) return;
      var channelName = this.asset.signalChannel;
    
      try {
        this.pubnub.signal(
          { channel: channelName, message: { action: action } },
          function(status: any, _resp: any) { if (status && status.error) console.error('signal error', status); }
        );
        this.pubnub.publish(
          { channel: channelName, message: { type: 'overlay', action: action } },
          function(status: any, _resp: any) { if (status && status.error) console.error('publish error', status); }
        );
      } catch (e) {
        console.error('PubNub send error', e);
      }
    }
    
    toggleDisplay(action: 'stream'|'weather'|'technical') {
      if (!this.isLiveContent) return;
    
      // toggle off if already selected
      if (this.currentOverlay === action) {
        this.applyActionState('clear');
        this.sendOverlayAction('clear');
        return;
      }
    
      // activate new overlay
      this.applyActionState(action);
      this.sendOverlayAction(action);
    }
    
    async startStream() {
      if (!this.isLiveContent) return;
      this.isStarting = true;
      this.applyActionState('start');
      this.sendOverlayAction('start');
      try {
        await new Promise(function(res){ setTimeout(res, 600); });
      } finally {
        this.isStarting = false;
      }
    }
    
    async stopStream() {
      if (!this.isLiveContent) return;
      this.isStopping = true;
      this.applyActionState('stop');
      this.sendOverlayAction('stop');
      try {
        await new Promise(function(res){ setTimeout(res, 600); });
      } finally {
        this.isStopping = false;
      }
    }
    
  
    // Remote updates come here
    handleRemoteOverlayChange(action: string) {
      if (action === 'start') {
        this.isLive = true;
        return;
      }
      if (action === 'stop') {
        this.isLive = false;
        return;
      }
      if (action === 'clear') {
        this.currentOverlay = null;
        return;
      }
      if (action === 'stream' || action === 'technical' || action === 'weather') {
        this.currentOverlay = action as any;
      }
    }
  
  

  // -------- GridH backward-compat migration --------
  // Old format: col[1] = [cameraCellOrNull]  (1 element, centre cam at index 0)
  // New format: col[1] = [adOrNull, centreCell, adOrNull]  (3 elements)
  // Detect old format: col[1].length === 1 AND the single entry is a camera cell (no type:'ad')
  migrateGridHLayout() {
    if (!this.layoutConfigs || !this.layoutConfigs.gridH) return;
    const col1 = this.layoutConfigs.gridH.layout[1];
    if (!col1) return;

    const isOldFormat = col1.length === 1 && col1[0] && (col1[0] as any).type !== 'ad';
    if (!isOldFormat) return;

    // Shift centre cam from index 0 → index 1, pad nulls at 0 and 2
    const centreCell = col1[0];
    this.layoutConfigs.gridH.layout[1] = [null as any, centreCell, null as any];
    this.svc.setLayouts(this.layoutConfigs);
  }

  // Old grid2 format already stores the two camera columns correctly.
  // We only need to ensure the extra top/bottom ad columns exist.
  migrateGrid2Layout() {
    if (!this.layoutConfigs || !this.layoutConfigs.grid2) return;
    const grid2 = this.layoutConfigs.grid2.layout;
    if (!grid2) return;

    let changed = false;
    while (grid2.length < 4) {
      grid2.push([]);
      changed = true;
    }

    const adTargets = [2, 3];
    for (let i = 0; i < 2; i++) {
      const cell = grid2[i] && grid2[i][0] ? grid2[i][0] as any : null;
      if (!cell || cell.type !== 'ad') continue;

      let moved = false;
      for (let j = 0; j < adTargets.length; j++) {
        const targetIndex = adTargets[j];
        if (!grid2[targetIndex] || !grid2[targetIndex][0]) {
          if (!grid2[targetIndex]) grid2[targetIndex] = [];
          grid2[targetIndex][0] = cell;
          grid2[i][0] = null as any;
          changed = true;
          moved = true;
          break;
        }
      }

      if (!moved) continue;
    }

    if (changed) this.svc.setLayouts(this.layoutConfigs);
  }

  // -------- Mapping helpers (same as your JS) --------
  getPlayerIndexFromColumnCell(layoutKey: LayoutKey, colIndex: number, cellIndex: number): number {
    if (layoutKey === 'grid9') return cellIndex * 3 + colIndex;
    if (layoutKey === 'grid4') return colIndex * 2 + cellIndex;
    if (layoutKey === 'grid2') {
      const mapping: number[][] = [[0], [1], [2], [3]];
      return mapping[colIndex][cellIndex];
    }
    if (layoutKey === 'gridH') {
      // col 1: [9=top-ad, 8=center-cam, 10=bottom-ad]
      const mapping: number[][] = [[0, 1, 2, 3], [9, 8, 10], [4, 5, 6, 7]];
      return mapping[colIndex][cellIndex];
    }
    return 0;
  }

  getColumnCellFromPlayerIndex(layoutKey: LayoutKey, playerIndex: number): { colIndex: number; cellIndex: number } {
    if (layoutKey === 'grid9') {
      // row-major: 0..8 as TL→TR, then next rows
      return { colIndex: playerIndex % 3, cellIndex: Math.floor(playerIndex / 3) };
    } 
    if (layoutKey === 'grid4') return { colIndex: Math.floor(playerIndex / 2), cellIndex: playerIndex % 2 };
    if (layoutKey === 'grid2') {
      const mapping: { [k: number]: [number, number] } = {
        0: [0, 0], // left cam
        1: [1, 0], // right cam
        2: [2, 0], // top ad
        3: [3, 0]  // bottom ad
      };
      return { colIndex: mapping[playerIndex][0], cellIndex: mapping[playerIndex][1] };
    }
    if (layoutKey === 'gridH') {
      const mapping: { [k: number]: [number, number] } = {
        0: [0, 0], 1: [0, 1], 2: [0, 2], 3: [0, 3],
        9: [1, 0],  // top ad slot
        8: [1, 1],  // center cam
        10: [1, 2], // bottom ad slot
        4: [2, 0], 5: [2, 1], 6: [2, 2], 7: [2, 3]
      };
      return { colIndex: mapping[playerIndex][0], cellIndex: mapping[playerIndex][1] };
    }
    return { colIndex: 0, cellIndex: 0 };
  }

  initializeLayoutStructure(layoutKey: LayoutKey) {
    const layout = this.layoutConfigs[layoutKey] ? this.layoutConfigs[layoutKey].layout : null;
    if (!layout || layout.length === 0) {
      if (layoutKey === 'grid9') this.layoutConfigs[layoutKey].layout = [[], [], []];
      else if (layoutKey === 'grid4') this.layoutConfigs[layoutKey].layout = [[], []];
      else if (layoutKey === 'grid2') this.layoutConfigs[layoutKey].layout = [[], [], [], []];
      else if (layoutKey === 'gridH') this.layoutConfigs[layoutKey].layout = [[], [], []];
    }

    if (layoutKey === 'grid2') {
      while (this.layoutConfigs[layoutKey].layout.length < 4) this.layoutConfigs[layoutKey].layout.push([]);
    }
  }

  // -------- Template helpers (keep HTML simple) --------
  getCell(layoutKey: LayoutKey, playerIndex: number): CellConfig | null {
    const pos = this.getColumnCellFromPlayerIndex(layoutKey, playerIndex);
    const layoutCfg = this.layoutConfigs[layoutKey];
    const layoutArr = layoutCfg && layoutCfg.layout ? layoutCfg.layout : [];
    const col = layoutArr[pos.colIndex] || [];
    const cell = col[pos.cellIndex];
    return cell ? cell : null;
  }

  isConfigured(layoutKey: LayoutKey, playerIndex: number): boolean {
    const cell = this.getCell(layoutKey, playerIndex);
    if (!cell) return false;
    return (cell as any).camIndex !== undefined || (cell as any).type === 'ad';
  }

  isAdCell(layoutKey: LayoutKey, playerIndex: number): boolean {
    const cell = this.getCell(layoutKey, playerIndex);
    return !!(cell && (cell as any).type === 'ad');
  }

  labelFor(layoutKey: LayoutKey, playerIndex: number, base: string): string {
    const cell = this.getCell(layoutKey, playerIndex);
    if (!cell) return `${base} ${playerIndex + 1}`;
    if ((cell as any).type === 'ad') {
      const provider = (cell as any).adProvider || 'image';
      return `Ad (${provider})`;
    }
    if ((cell as any).camIndex !== undefined) {
      return `${base} ${(cell as any).camIndex + 1}`;
    }
    return `${base} ${playerIndex + 1}`;
  }

  clearCurrentConfig() {
    if (!this.currentPlayer) return;

    const { layoutKey, playerIndex } = this.currentPlayer;
    const pos = this.getColumnCellFromPlayerIndex(layoutKey, playerIndex);
    this.initializeLayoutStructure(layoutKey);
    const col = this.layoutConfigs[layoutKey].layout[pos.colIndex];
    while (col.length <= pos.cellIndex) col.push(null as any);
    col[pos.cellIndex] = null as any;
    this.svc.setLayouts(this.layoutConfigs);

    if (this.showAdPopup) this.closeAdPopup();
    else this.closeConfigPopup();

    this.updateStats();
  }

  private isDedicatedAdSlot(layoutKey: LayoutKey, playerIndex: number): boolean {
    return (layoutKey === 'gridH' && (playerIndex === 9 || playerIndex === 10))
      || (layoutKey === 'grid2' && (playerIndex === 2 || playerIndex === 3));
  }

  private populateCameraForm(layoutKey: LayoutKey, playerIndex: number, existing: any) {
    const defaults = this.getDefaultSlotBox(layoutKey, playerIndex);
    this.form_camIndex = (existing && existing.camIndex != null) ? existing.camIndex + 1 : null;
    this.form_width    = (existing && existing.width)  || defaults.width;
    this.form_height   = (existing && existing.height) || defaults.height;
    this.form_x        = (existing && existing.x)      || defaults.x;
    this.form_y        = (existing && existing.y)      || defaults.y;
  }

  private populateAdForm(existing: any) {
    this.form_adProvider  = (existing && existing.adProvider)  || 'image';
    this.form_imageUrl    = (existing && existing.imageUrl)    || '';
    this.form_redirectUrl = (existing && existing.redirectUrl) || '';
    this.form_alt         = (existing && existing.alt)         || '';
    this.form_adClient    = (existing && existing.adClient)    || '';
    this.form_adSlot      = (existing && existing.adSlot)      || '';
    this.form_adUnitPath  = (existing && existing.adUnitPath)  || '';
    this.form_adSizes     = (existing && existing.adSizes) ? JSON.stringify(existing.adSizes) : '[[970,250],[728,90]]';
    this.form_adDivId     = (existing && existing.adDivId)     || '';
  }

  private getDefaultSlotBox(layoutKey: LayoutKey, playerIndex: number): { width: string; height: string; x: string; y: string } {
    if (layoutKey === 'grid2') {
      if (playerIndex === 0) return { width: '50%', height: '53.1%', x: '0%', y: '23%' };
      if (playerIndex === 1) return { width: '50%', height: '53.1%', x: '50%', y: '23%' };
      if (playerIndex === 2) return { width: '100%', height: '23%', x: '0%', y: '0%' };
      if (playerIndex === 3) return { width: '100%', height: '23.9%', x: '0%', y: '76.1%' };
    }

    if (layoutKey === 'gridH') {
      if (playerIndex === 9) return { width: '50%', height: '25%', x: '25%', y: '0%' };
      if (playerIndex === 10) return { width: '50%', height: '25%', x: '25%', y: '75%' };
    }

    return { width: '', height: '', x: '', y: '' };
  }

  private saveAdConfig(closeTarget: 'ad' | 'config') {
    if (!this.currentPlayer) return;

    const { layoutKey, playerIndex } = this.currentPlayer;
    const pos = this.getColumnCellFromPlayerIndex(layoutKey, playerIndex);
    this.initializeLayoutStructure(layoutKey);
    const col = this.layoutConfigs[layoutKey].layout[pos.colIndex];
    while (col.length <= pos.cellIndex) col.push(null as any);

    const box = this.getDefaultSlotBox(layoutKey, playerIndex);
    const cell: any = {
      type: 'ad',
      adProvider: this.form_adProvider,
      x: box.x,
      y: box.y,
      width: box.width,
      height: box.height
    };

    if (this.form_adProvider === 'image') {
      if (!this.form_imageUrl || !this.form_redirectUrl) {
        this.toastrService.warning('Image URL and Redirect URL are required');
        return;
      }
      cell.imageUrl    = this.form_imageUrl;
      cell.redirectUrl = this.form_redirectUrl;
      cell.alt         = this.form_alt;
    } else if (this.form_adProvider === 'adsense') {
      if (!this.form_adClient || !this.form_adSlot) {
        this.toastrService.warning('Ad Client and Ad Slot are required for AdSense');
        return;
      }
      cell.adClient = this.form_adClient;
      cell.adSlot   = this.form_adSlot;
    } else if (this.form_adProvider === 'gam') {
      if (!this.form_adUnitPath || !this.form_adDivId) {
        this.toastrService.warning('Ad Unit Path and Div ID are required for GAM');
        return;
      }
      cell.adUnitPath = this.form_adUnitPath;
      cell.adDivId    = this.form_adDivId;
      try { cell.adSizes = JSON.parse(this.form_adSizes); } catch (_) { cell.adSizes = [[970, 250]]; }
    }

    col[pos.cellIndex] = cell;
    this.svc.setLayouts(this.layoutConfigs);

    if (closeTarget === 'ad') this.closeAdPopup();
    else this.closeConfigPopup();

    this.updateStats();
  }
  
  

  // -------- Toggles / Stats --------
  onToggleLayout(layoutKey: LayoutKey, enabled: boolean) {
    this.layoutStates[layoutKey] = enabled;
    this.updateStats();
  }

  updateStats() {
    // enabled
    let enabled = 0;
    for (const k in this.layoutStates) {
      if (this.layoutStates.hasOwnProperty(k) && (this.layoutStates as any)[k]) enabled++;
    }
    // configured cells
    let configured = 0;
    const layouts = this.layoutConfigs;
    for (const key in layouts) {
      if (layouts.hasOwnProperty(key)) {
        const lcfg = (layouts as any)[key] as LayoutConfig;
        if (lcfg && lcfg.layout) {
          for (let i = 0; i < lcfg.layout.length; i++) {
            const col = lcfg.layout[i];
            for (let j = 0; j < col.length; j++) {
              const cell = col[j];
              if (cell && (cell as any).camIndex !== undefined) configured++;
            }
          }
        }
      }
    }
    this.enabledLayouts = enabled;
    this.configuredStreams = configured;
    this.lastUpdated = new Date().toLocaleTimeString();
  }

  // -------- Config popup (camera) --------
  openConfigPopup(layoutKey: LayoutKey, playerIndex: number) {
    if (!this.layoutStates[layoutKey]) return;

    this.currentPlayer = { layoutKey, playerIndex };
    this.initializeLayoutStructure(layoutKey);
    this.resetFormFields();

    // Dedicated ad slots open the ad popup
    if (this.isDedicatedAdSlot(layoutKey, playerIndex)) {
      const pos = this.getColumnCellFromPlayerIndex(layoutKey, playerIndex);
      const existing = ((this.layoutConfigs[layoutKey].layout[pos.colIndex] || [])[pos.cellIndex]) as any;
      this.populateAdForm(existing);
      this.showAdPopup = true;
      return;
    }

    // All other slots — original camera stream flow
    const pos = this.getColumnCellFromPlayerIndex(layoutKey, playerIndex);
    const col = this.layoutConfigs[layoutKey].layout[pos.colIndex] || [];
    const existing = col[pos.cellIndex] as any;
    this.populateCameraForm(layoutKey, playerIndex, existing && existing.type !== 'ad' ? existing : null);

    this.showConfigPopup = true;
  }

  closeConfigPopup() {
    this.showConfigPopup = false;
    this.currentPlayer = null;
    this.resetFormFields();
  }

  onAdImageSelected(event: any) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    this.form_adImageUploading = true;
    this.productConfigurationService.uploadFile(file, awsPath.asset).then(res => {
      if (res && res.Location) {
        this.form_imageUrl = res.Location;
      } else {
        this.toastrService.warning('Image upload failed');
      }
      this.form_adImageUploading = false;
    }).catch(() => {
      this.toastrService.warning('Image upload failed');
      this.form_adImageUploading = false;
    });
  }

  closeAdPopup() {
    this.showAdPopup = false;
    this.currentPlayer = null;
    this.resetFormFields();
  }

  submitAdConfig() {
    this.saveAdConfig('ad');
  }

  clearAdConfig() {
    this.clearCurrentConfig();
  }

  submitConfig() {
    if (!this.currentPlayer) return;

    const layoutKey   = this.currentPlayer.layoutKey;
    const playerIndex = this.currentPlayer.playerIndex;

    const pos = this.getColumnCellFromPlayerIndex(layoutKey, playerIndex);

    this.initializeLayoutStructure(layoutKey);
    const col = this.layoutConfigs[layoutKey].layout[pos.colIndex];

    // --- Clear cell ---
    const raw = (this.form_camIndex !== null && this.form_camIndex !== undefined)
                  ? String(this.form_camIndex).trim() : '';
    if (raw.toLowerCase() === 'o' || raw === '0') {
      while (col.length <= pos.cellIndex) col.push(null as any);
      col[pos.cellIndex] = null as any;
      this.svc.setLayouts(this.layoutConfigs);
      this.closeConfigPopup();
      this.resetFormFields();
      this.updateStats();
      return;
    }

    if (!this.form_width || !this.form_height || !this.form_x || !this.form_y) {
      this.toastrService.warning('Please fill Width, Height, X, and Y fields');
      return;
    }

    // --- Camera cell ---
    const userFacing = Number(raw);
    if (isNaN(userFacing) || userFacing < 1 || userFacing > 9) {
      this.toastrService.warning('Please enter Camera Index 1–9');
      return;
    }

    while (col.length <= pos.cellIndex) col.push(null as any);
    col[pos.cellIndex] = {
      camIndex: userFacing - 1,
      width: this.form_width,
      height: this.form_height,
      x: this.form_x,
      y: this.form_y
    };

    this.svc.setLayouts(this.layoutConfigs);
    this.closeConfigPopup();
    this.resetFormFields();
    this.updateStats();
  }

  private resetFormFields() {
    this.form_isAdOnlySlot = false;
    this.form_cellType = 'camera';
    this.form_camIndex = null;
    this.form_width = this.form_height = this.form_x = this.form_y = '';
    this.form_adProvider = 'image';
    this.form_imageUrl = this.form_redirectUrl = this.form_alt = '';
    this.form_adImageUploading = false;
    this.form_adClient = this.form_adSlot = '';
    this.form_adUnitPath = this.form_adDivId = '';
    this.form_adSizes = '[[970,250],[728,90]]';
  }
  
  

  // -------- Asset edit popup --------
  editAssetInfo(assetPath) {
    const existing = this.svc.defaultAssetData(assetPath);
    const streams = existing.streamUrls ? existing.streamUrls.slice(0) : [];
    while (streams.length < 9) streams.push({ name: 'Camera ' + (streams.length + 1), url: '' });
    console.log(existing,assetPath)
    this.tmpAsset = {
      id: existing.id,
      videoUrl: existing.videoUrl,
      video_H_Url: existing.video_H_Url,
      video_dual_Url: existing.video_dual_Url,
      video_quad_Url: existing.video_quad_Url,
      audiourl: existing.audiourl,
      programcutUrl: existing.programcutUrl,
      streamUrls: streams,
      Program:existing.Program,
      contentType: existing.contentType,
      signalChannel: existing.signalChannel,
      chatEnabled: this.getChatEnabled(existing),
      chatChannel: this.getChatChannel(existing),
      chatEnablePrivate: this.getChatEnablePrivate(existing),
      chatRoomPrefix: this.getChatRoomPrefix(existing),
      multiViewEnabled:existing.multiViewEnabled
    };
    console.log("asdasd",this.tmpAsset)

  }

  private getChatEnabled(asset: any): boolean {
    return !!(asset && (asset.chatEnabled || (asset.chatConfig && asset.chatConfig.showChat)));
  }

  private getChatChannel(asset: any): string {
    return (asset && (asset.chatChannel || (asset.chatConfig && asset.chatConfig.channel))) || '';
  }

  private getChatEnablePrivate(asset: any): boolean {
    return !!(asset && (asset.chatEnablePrivate || (asset.chatConfig && asset.chatConfig.enablePrivateRooms)));
  }

  private getChatRoomPrefix(asset: any): string {
    return (asset && (asset.chatRoomPrefix || (asset.chatConfig && asset.chatConfig.roomPrefix))) || '';
  }

  openeditAssetPopup(){ this.showAssetEditPopup = true; }

  closeAssetEditPopup() { this.showAssetEditPopup = false; }

  saveAssetInfo() {
    if (this.tmpAsset.contentType === 'live') {
      if (!this.tmpAsset.signalChannel || !this.tmpAsset.signalChannel.trim()) {
        alert('Signal channel is required for LIVE content.');
        return;
      }
    }
    if (this.tmpAsset.chatEnabled) {
      if (!this.tmpAsset.chatChannel || !this.tmpAsset.chatChannel.trim()) {
        alert('Chat channel is required when Chat is enabled.');
        return;
      }
    }
 
    this.svc.setAssetData(this.tmpAsset);
    this.asset = this.svc.getAssetData(this.assetPath);


    const has = (s?: string) => !!(s && s.trim().length > 0);

    const grid9Enabled = has(this.asset.videoUrl);
    const gridHEnabled = has(this.asset.video_H_Url);
    const grid2Enabled = has(this.asset.video_dual_Url);
    const grid4Enabled = has(this.asset.video_quad_Url);
  
    this.layoutStates.grid9 = grid9Enabled;
    this.layoutStates.gridH  = gridHEnabled;
    this.layoutStates.grid2  = grid2Enabled;
    this.layoutStates.grid4  = grid4Enabled;


    this.maybeInitPubNub();

    this.closeAssetEditPopup();
  }

  // -------- Export / Backend --------
  generateBackendJSON() {
    return this.svc.generateBackendJSON(this.layoutConfigs,this.assetPath);
  }

  exportConfig() {
    const data = this.generateBackendJSON();
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = (window.URL || (window as any).webkitURL).createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'stream-config-export.json';
    a.click();
    setTimeout(function () {
      (window.URL || (window as any).webkitURL).revokeObjectURL(url);
    }, 0);
  }

  sendToBackend() {
    let config = this.generateBackendJSON();
    config.asset_id = this.assetPath,
    config.schemaVersion = 1; // keep this asset on the old model so it reopens in the v1 editor
    this.svc.sendConfig(config).subscribe(
      () => { this.toastrService.success('Configuration saved successfully!'); this.ngOnInit() },
      (err) => { console.error(err); this.toastrService.warning('Failed to send configuration.'); }
    );
  }

  resetAll() {
    if (!confirm('Reset all configurations?')) return;
    this.svc.clearLayoutAndAsset()
    this.layoutConfigs = this.svc.getdefaultLayouts();
    this.layoutStates.grid9 = true;
    this.layoutStates.grid4 = true;
    this.layoutStates.grid2 = true;
    this.layoutStates.gridH = true;

    this.svc.setLayouts(this.layoutConfigs);
    this.updateStats();
    this.toastrService.success('All configurations reset!');
  }


  remove() {
    if (!confirm('Reset all configurations?')) return;
    this.svc.clearLayoutAndAsset()
    this.layoutConfigs = this.svc.getLayouts();
    this.layoutStates.grid9 = true;
    this.layoutStates.grid4 = true;
    this.layoutStates.grid2 = true;
    this.layoutStates.gridH = true;

    this.svc.setLayouts(this.layoutConfigs);
    this.updateStats();
    this.toastrService.success('All configurations removed!');
  }

  // -------- Global key handlers --------
  @HostListener('document:keydown', ['$event'])
  onKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      if (this.showConfigPopup) this.closeConfigPopup();
      if (this.showAssetEditPopup) this.closeAssetEditPopup();
    }
  }
}
